import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Container, Link, IconButton, Menu, MenuItem, Avatar } from '@mui/material';
import ImageCarousel from '../carousel/ImageCarousel';
import { useGlobalContext } from '../../context/GlobalProvider';
import { logout as appwriteLogout } from '../../lib/appwrite';
import { useNavigate, useLocation } from 'react-router-dom';

const Layout = ({ children }) => {
  const { user } = useGlobalContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await appwriteLogout();
      navigate('/');
    } catch (error) {
      console.error('Error during logout:', error);
      navigate('');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <img
            src={require('../../assets/logo-ags.png')}
            alt="Logo Asociación de Golf del Sur"
            style={{ maxWidth: '52px', cursor: 'pointer', borderRadius: '50%' }}
            onClick={() => navigate('/home')}
          />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, ml: 3 }}>
            Sistema de Inscripción para Giras y Torneos
          </Typography>
          
          {/* Profile Icon and Menu */}
          {user && (location.pathname === '/home' || location.pathname === '/settings') && (
            <>
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
              >
                <Avatar 
                  src={user?.avatar}
                  sx={{ 
                    width: 32, 
                    height: 32,
                    bgcolor: 'primary.light'
                  }}
                >
                  {user?.email?.[0]?.toUpperCase()}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={() => {
                    handleClose();
                    if (location.pathname === '/settings') {
                        navigate('/home');
                    } else {
                        navigate('/settings');
                    }
                }}>
                    {location.pathname === '/settings' ? 'Inicio' : 'Ajustes'}
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  Cerrar sesión
                </MenuItem>
              </Menu>
            </>
          )}
        </Toolbar>
      </AppBar>
      

      <Box component="main" sx={{ 
        flex: 1,
        width: '100%',
        position: 'relative'
      }}>
        {children}
      </Box>
      {/* Carousel Section */}
      <Box sx={{ width: '100%', py: 3, backgroundColor: (theme) => theme.palette.grey[200] }}>
          <ImageCarousel />
      </Box>
      <Box
        component="footer"
        sx={{
          mb: 'auto',
          backgroundColor: (theme) => theme.palette.grey[200],
        }}
      >
          
        <Container maxWidth="sm" sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {new Date().getFullYear()} Asociación de Golf del Sur AC | 
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => window.location.href = 'http://www.golfsur.org/registro/golfsur_condicionesdeusodelsistema.pdf'}
                      sx={{ cursor: 'pointer' }}
                    >
                      Al registrarse acepta las condiciones de uso de sistema.
                    </Link>
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Layout; 